import { action } from "@ember/object"
import Component from "@glimmer/component"
import $ from "jquery"

export default class XModalDialog extends Component {
  get _translucentOverlay() {
    return this.args.translucentOverlay ?? true
  }

  @action
  onInsert() {
    $("body").addClass("modal-open")
  }

  willDestroy() {
    super.willDestroy(...arguments)
    $("body").removeClass("modal-open")
  }
}
